// The installed app's launch splash. index.html draws it (cream, the mark centred: the same look
// as the Android app's own splash) over everything on a phone in standalone mode, so the first
// frames Chrome paints look like the splash the app just showed rather than a blank page, the
// website's header or a placeholder. It leaves once the first screen is ready: Earn says so when
// its data is in, Layout for every other screen as soon as the session is known, and a timer here
// (plus a CSS animation in index.html, in case this code never runs) so nothing can keep it up.
const ID = 'gp-splash';
const MAX_MS = 5000;
let gone = false;

/** Fades the launch splash out, once; a no-op in a browser tab, where it was never shown. */
export function hideLaunchSplash() {
  if (gone) return;
  gone = true;
  const el = document.getElementById(ID);
  if (!el) return;
  el.classList.add('out');
  window.setTimeout(() => el.remove(), 300);
}

/** Whether the splash is on show, so a screen change under it needs no transition (main.tsx). */
export function launchSplashShowing(): boolean {
  if (gone) return false;
  const el = document.getElementById(ID);
  return !!el && getComputedStyle(el).display !== 'none';
}

/** Routes that see to the splash themselves: Earn takes it down when its data is in; "/" and
 *  "/app" hand over to Earn or to the welcome screen, which takes it down. */
export const KEEPS_SPLASH = new Set(['/', '/app', '/earn']);

if (typeof window !== 'undefined') window.setTimeout(hideLaunchSplash, MAX_MS);
